import { dataCollectionStore } from '../stores/dataCollectionOverview.store';
import {
	navigationStore,
	companyProfileStore,
	ghgReportingStore,
	boundaryStore,
	eidrStore,
	benchmarkStore,
	sbtiStore,
	summaryStore,
} from '../stores';

// Unified hook that provides access to all onboard stores
// This maintains backward compatibility while using split stores internally
export const useOnboardStore = () => ({
	// Navigation store
	selectedPage: navigationStore.selectedPage,
	handlePageChange: navigationStore.handlePageChange,

	// Company Profile store
	companyProfile: companyProfileStore.companyProfile,
	isCompanyProfileChanged: companyProfileStore.isCompanyProfileChanged,
	getCompany: companyProfileStore.getCompany,
	updateCompany: companyProfileStore.updateCompany,
	handleChangeCompanyProfile: companyProfileStore.handleChangeCompanyProfile,

	// GHG Reporting store
	GHGReportingForm: ghgReportingStore.GHGReportingForm,
	isGHGReportingChanged: ghgReportingStore.isGHGReportingChanged,
	getGHGReporting: ghgReportingStore.getGHGReporting,
	updateGHGReporting: ghgReportingStore.updateGHGReporting,
	handleChangeGHGReporting: ghgReportingStore.handleChangeGHGReporting,

	// Boundary store
	childCompanies: boundaryStore.childCompanies,
	selectedNode: boundaryStore.selectedNode,
	isCompanyModalOpen: boundaryStore.isCompanyModalOpen,
	isDeleteConfirmModalOpen: boundaryStore.isDeleteConfirmModalOpen,
	companyForm: boundaryStore.companyForm,
	isTypeLocked: boundaryStore.isTypeLocked,
	formErrors: boundaryStore.formErrors,
	deleteTargetName: boundaryStore.deleteTargetName,
	getChildCompanies: boundaryStore.getChildCompanies,
	selectNode: boundaryStore.selectNode,
	openCreateModal: boundaryStore.openCreateModal,
	openEditModal: boundaryStore.openEditModal,
	closeCompanyModal: boundaryStore.closeCompanyModal,
	setCompanyFormValue: boundaryStore.setCompanyFormValue,
	saveCompany: boundaryStore.saveCompany,
	openBoundaryDeleteConfirmModal: boundaryStore.openDeleteConfirmModal,
	closeDeleteConfirmModal: boundaryStore.closeDeleteConfirmModal,
	confirmDeleteCompany: boundaryStore.confirmDeleteCompany,

	// EIDR store
	EIDRData: eidrStore.EIDRData,
	isEIDRChanged: eidrStore.isEIDRChanged,
	getEIDR: eidrStore.getEIDR,
	saveEIDR: eidrStore.saveEIDR,
	handleChangeEIDR: eidrStore.handleChangeEIDR,

	// Benchmark store
	IPBData: benchmarkStore.IPBData,
	IPBDataForm: benchmarkStore.IPBDataForm,
	isIPBChanged: benchmarkStore.isIPBChanged,
	errors: benchmarkStore.errors,
	isBenchmarksDeleteConfirmModalOpen: benchmarkStore.isDeleteConfirmModalOpen,
	selectedDeleteCompanyId: benchmarkStore.selectedDeleteCompanyId,
	selectedCompanyName: benchmarkStore.selectedCompanyName,
	setErrors: benchmarkStore.setErrors,
	openBenchmarksDeleteConfirmModal: benchmarkStore.openDeleteConfirmModal,
	closeBenchmarksDeleteConfirmModal: benchmarkStore.closeDeleteConfirmModal,
	getIPB: benchmarkStore.getIPB,
	saveIPBData: benchmarkStore.saveIPBData,
	handleSelectIPB: benchmarkStore.handleSelectIPB,
	deleteIPBData: benchmarkStore.deleteIPBData,
	handleChangeIPB: benchmarkStore.handleChangeIPB,

	// SBTi store
	SBTiSettingForm: sbtiStore.SBTiSettingForm,
	isSBTiChanged: sbtiStore.isSBTiChanged,
	initialYear: sbtiStore.initialYear,
	currentYear: sbtiStore.currentYear,
	baseYearOptions: sbtiStore.baseYearOptions,
	targetYearOptions: sbtiStore.targetYearOptions,
	getSBTI: sbtiStore.getSBTI,
	saveSBTI: sbtiStore.saveSBTI,
	handleGetBaseYearOptions: sbtiStore.handleGetBaseYearOptions,
	handleGetTargetYearOptions: sbtiStore.handleGetTargetYearOptions,
	handleChangeSBTiSetting: sbtiStore.handleChangeSBTiSetting,
	handleCheckReductionScope: sbtiStore.handleCheckReductionScope,
	getTotalTargetReduction: sbtiStore.getTotalTargetReduction,
	totalReductionBaseline: sbtiStore.totalReductionBaseline,

	// Summary store
	isGeneralConfirmationModalOpen: summaryStore.isGeneralConfirmationModalOpen,
	openGeneralConfirmationModal: summaryStore.openGeneralConfirmationModal,
	closeGeneralConfirmationModal: summaryStore.closeGeneralConfirmationModal,
	handleSaveSummary: summaryStore.handleSaveSummary,
});

export const useDataCollectionOverveiwStore = () => dataCollectionStore;

// Export individual stores for direct access if needed
export {
	navigationStore,
	companyProfileStore,
	ghgReportingStore,
	boundaryStore,
	eidrStore,
	benchmarkStore,
	sbtiStore,
	summaryStore,
};
